<template>
    <module-card :nextDisabled="nextDisabled">
        <video controls controlslist="nodownload" @playing="playing" @ended="ended">
            <source :src="require('@/assets/PsOnAgainOffAgainBottomLine/PsbottomlinePt1.mp4')" type="video/mp4" />
        </video>
    </module-card>
</template>

<script>
    export default {
        data() {
            return {
                videoStarted: false,
                videoCompleted: false
            };
        },
        methods: {
            nextDisabled() {
                return !(this.videoStarted && this.videoCompleted);
            },
            playing() {
                this.videoStarted = true;
            },
            ended() {
                this.videoCompleted = true;
            }
        }
    };
</script>

<style scoped>
    video {
        width: 100% !important;
        height: auto !important;
    }
</style>
